import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Trash2 } from 'lucide-react';
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/components/ui/use-toast";

interface DeleteLessonDialogProps {
  lessonId: string;
  lessonTitle: string;
  onDelete: () => void;
}

export const DeleteLessonDialog = ({ lessonId, lessonTitle, onDelete }: DeleteLessonDialogProps) => {
  const handleDelete = async () => {
    try {
      console.log('Attempting to delete lesson:', lessonId);
      
      const { error: quizError } = await supabase
        .from('quiz_questions')
        .delete()
        .eq('lesson_id', lessonId);

      if (quizError) {
        console.error('Error deleting quiz questions:', quizError);
        throw quizError;
      }

      const { error: lessonError } = await supabase
        .from('lessons')
        .delete()
        .eq('id', lessonId);

      if (lessonError) {
        console.error('Error deleting lesson:', lessonError);
        throw lessonError;
      }

      toast({
        title: "Lección eliminada",
        description: "La lección ha sido eliminada correctamente",
      });

      onDelete();
    } catch (error) {
      console.error('Error in handleDelete:', error);
      toast({
        title: "Error",
        description: "No se pudo eliminar la lección",
        variant: "destructive",
      });
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          variant="destructive"
          size="sm"
          className="flex-1 flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white transition-colors"
        >
          <Trash2 className="h-4 w-4" />
          <span className="text-sm">Eliminar</span>
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>¿Estás seguro?</AlertDialogTitle>
          <AlertDialogDescription>
            Esta acción no se puede deshacer. Se eliminará permanentemente la lección
            &quot;{lessonTitle}&quot; y todas sus preguntas asociadas.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-gray-100 hover:bg-gray-200 text-gray-700">
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            Eliminar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};